'use client';

import * as React from 'react';
export const CalendarGridDayEventContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridDayEventContext.displayName = "CalendarGridDayEventContext";
export function useCalendarGridDayEventContext() {
  const context = React.useContext(CalendarGridDayEventContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: `CalendarGridDayEventContext` is missing. CalendarGrid DayEvent parts must be placed within <CalendarGrid.DayEvent />.');
  }
  return context;
}